<template>
  <div class="tm-visual-ghost wt-lightbox-asset" :style="styleObj">
    <div class="-asset -image">
      <template v-if="isWallpaper">
        <div class="-inner" :style="wallpaperStyleObj" />
      </template>
      <template v-else>
        <div class="-inner">
          <img
            v-if="!imageError"
            :src="src"
            @error="imageError = true"
            draggable="false"
          />
          <div v-else class="-error">
            <span class="wticon wticon-picture-sun" />
          </div>
        </div>
      </template>
    </div>

    <div v-if="$props.mode" class="-mode-layer">
      <template v-if="$props.mode === VisualGhostMode.DEFAULT">
        <i class="wticon wticon-plus" />
        <div class="-label">Drag to Timeline</div>
      </template>
      <template v-else-if="$props.mode === VisualGhostMode.DEFAULT_SCENE">
        <i class="wticon wticon-plus" />
        <div class="-label">Drag to Collage</div>
      </template>
      <template v-else-if="$props.mode === VisualGhostMode.INSERT">
        <i class="wticon wticon-arrow-down" />
        <div class="-label">Insert</div>
      </template>
      <template v-else-if="$props.mode === VisualGhostMode.INSERT_BETWEEN">
        <i class="wticon wticon-arrow-down" />
        <div class="-label">Insert Between</div>
      </template>
      <template v-else-if="$props.mode === VisualGhostMode.REPLACE_OVERLAY">
        <i class="wticon wticon-replace" />
        <div class="-label">Replace</div>
      </template>
      <template v-else-if="$props.mode === VisualGhostMode.REPLACE_DEFAULT">
        <i class="wticon wticon-replace" />
        <div class="-label">Replace</div>
      </template>
      <template v-else-if="$props.mode === VisualGhostMode.REPLACE_SCENE">
        <i class="wticon wticon-replace" />
        <div class="-label">Replace</div>
        <div class="-small-label">or hold to insert</div>
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          width="150px"
          height="87px"
          viewBox="0 0 150 87"
          class="-path-to-replace-svg"
        >
          <path class="-path-to-replace" d="M75 0 H150 V87 H0 V0 H75 Z" />
        </svg>
      </template>
    </div>
  </div>
</template>

<script>
import app from 'app';
import { mapState } from 'vuex';
import { VisualGhostMode } from '../../api/model';

export default {
  name: 'tm-visual-ghost',

  props: {
    asset: { type: Object, required: true },
    point: { type: Object, required: true },
    mode: { type: String, required: false, default: null },
    isInside: { type: Boolean, required: true },
  },

  data() {
    return {
      imageError: false,
    };
  },

  computed: {
    ...mapState('timemachine', {
      zMovableGhost: (state) =>
        state.CONST.Z_ORDER.MAIN.indexOf('zMovableGhost'),
      pxRowBlankTop: (state) => state.cssVariables.pxRowBlankTop,
      pxAssetHeight: (state) => state.cssVariables.pxAssetHeight,
      pxAssetWidth: (state) => state.cssVariables.pxAssetWidth,
    }),

    VisualGhostMode() {
      return VisualGhostMode;
    },

    isWallpaper() {
      return app.assetType.isWALLPAPER(this.$props.asset);
    },

    wallpaperStyleObj() {
      return app.computeBgFromColorData(
        this.$props.asset.wallpaperMetaData.wallpaperData
      );
    },

    src() {
      return this.mixinSrc(
        this.$props.asset.realTimePreviewResultData?.thumbnail ||
          this.$props.asset.previewResultData?.thumbnail ||
          this.$props.asset.metadata.thumbnail256x144Url ||
          this.$props.asset.metadata.thumbnail160x90Url ||
          this.$props.asset.metadata.urlCdn ||
          this.$props.asset.metadata.url ||
          null
      );
    },

    styleObj() {
      return {
        top: `${this.point.y}px`,
        left: `${this.point.x}px`,
        width: `${this.pxAssetWidth}px`,
        height: `${this.pxAssetHeight}px`,
        'z-index': this.zMovableGhost,
        transform: 'translate3d(-50%, -80%, 0)',
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.tm-visual-ghost {
  position: absolute;
  box-shadow: -3px 3px 5px rgba(0, 0, 0, 0.5);

  cursor: var(--tm-cursor);
  .-inner {
    cursor: var(--tm-cursor);
  }

  > .-asset {
    height: 100%;
  }

  > .-mode-layer {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;

    z-index: 1;

    font-weight: $font-weight-medium;
    color: white;
    background-color: rgba(#000, 0.6);
    text-shadow: 0 2px 2px rgba(#000, 0.5);

    > .-label {
      font-size: 14px;
    }
    > .-small-label {
      font-size: 12px;
    }
    > .wticon {
      font-size: 20px;
    }
    > .wticon + .-label {
      margin-top: 0;
    }

    > .-path-to-replace-svg {
      position: absolute;
      pointer-events: none;

      > .-path-to-replace {
        fill: transparent;
        stroke: rgba(255, 255, 255, 0.8);
        stroke-width: 6px;
        stroke-dasharray: 474;
        stroke-dashoffset: 474;
        animation: path-to-replace-animation 2.25s linear;
      }
    }

    @keyframes path-to-replace-animation {
      from {
        stroke-dashoffset: 474;
      }
      to {
        stroke-dashoffset: 0;
      }
    }
  }
}
</style>
